export default __webpack_public_path__ + "static/media/sc-crm@3x.ef0eddf0.png";